/*
* Palo Alto Theme - Custom JS
*/
(function() {
  // =====================================================
  // HIDE: Siblings color navigation (fieldset.siblings)
  // =====================================================
  document.head.insertAdjacentHTML('beforeend',
    '<style>fieldset.siblings,.product__block:has(fieldset.siblings){display:none!important}</style>'
  );

  // =====================================================
  // FIX: Prevent page scroll when selecting color option
  //
  // Palo Alto calls updateProductImage -> scrollTo() after a
  // variant change, sometimes via a nested setTimeout. We keep
  // the block flag for 300ms to cover async paths.
  // =====================================================
  var _blockNextSmooth = false;
  var _blockTimer = null;

  document.addEventListener('change', function(e) {
    if (e.target && e.target.matches('[data-single-option-selector]')) {
      _blockNextSmooth = true;
      if (_blockTimer) clearTimeout(_blockTimer);
      _blockTimer = setTimeout(function() {
        _blockNextSmooth = false;
        _blockTimer = null;
      }, 300);
    }
  }, true);

  var _origScrollTo = window.scrollTo.bind(window);
  window.scrollTo = function(optionsOrX, y) {
    if (_blockNextSmooth &&
        typeof optionsOrX === 'object' &&
        optionsOrX !== null &&
        optionsOrX.behavior === 'smooth') {
      return;
    }
    return _origScrollTo.apply(window, arguments);
  };
})();